import formularioService from '../../services/FormularioService'

async function carregarFormulario (context, payload) {   
  const formulario = await formularioService.obterFormularioPorId(payload)  
  context.commit('LOAD_FORMULARIO', formulario)
}

async function carregarFormularioAssistido (context, payload) {   
  const formulario = await formularioService.obterFormularioAssistidoPorId(payload)  
  context.commit('LOAD_FORMULARIO', formulario)
  context.commit('DEFINIR_FORMULARIO_ASSISTIDO', true)
}

function descarregarFormulario(context,payload){
  context.commit('LIMPAR_FORMULARIO',payload);
}

function responderPergunta (context, payload) { 
  context.commit('RESPONDER_PERGUNTA', payload)
}

function removerRespostaPergunta(context, payload){
  context.commit('REMOVER_RESPOSTA_PERGUNTA', payload)
}

function limparRespostasPergunta(context, payload){
  context.commit(`LIMPAR_RESPOSTAS_PERGUNTA`,payload);
}

function carregarInformacaoParticipante (context, payload) {
  context.commit('CARREGAR_INFORMACAO_PARTICIPANTE', payload)
}

function adicionarRestriacaoDePreValidacaoResposta(context, codigoValidacao){
  context.commit('ADD_RESTRICAO_PRE_VALIDACAO',codigoValidacao)
}

function removerRestriacaoDePreValidacaoResposta(context, codigoValidacao){
  context.commit('REMOVER_RESTRICAO_PRE_VALIDACAO',codigoValidacao)
}

function addPerguntaSessaoFormulario(context){
  context.commit('ADD_PERGUNTA_SESSAO',{})
}

function verificarPerguntaEncadeada(context, payload){
  context.commit('VERIFICAR_ENCADEAMENTO_PERGUNTA',payload);
}

function habilitarVerificaoResposta(context, payload){
  context.commit('HABILITAR_VERIFICACAO_RESPOSTA',payload);
}

function definirFormularioComoAssistido(context, payload) {
  context.commit('DEFINIR_FORMULARIO_COMO_ASSISTIDO',payload);
}

responderPergunta
export default {
  carregarFormulario,
  carregarFormularioAssistido,
  descarregarFormulario,
  responderPergunta,
  removerRespostaPergunta,
  limparRespostasPergunta,
  carregarInformacaoParticipante,
  adicionarRestriacaoDePreValidacaoResposta,
  removerRestriacaoDePreValidacaoResposta,
  addPerguntaSessaoFormulario,
  verificarPerguntaEncadeada,
  habilitarVerificaoResposta,
  definirFormularioComoAssistido
}



// WEBPACK FOOTER //
// ./src/store/actions/formulario.action.js